import { Box, CircularProgress, styled, Tab, Tabs } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import CampaignCard from "components/campaigncard";
import InterviewCard from "components/interviewcard";
import React from "react";

const TopTab = styled(Tab)({
  justifyContent: "flex-start",
  fontWeight: "600",
  textTransform: "capitalize",
  padding: "10px 20px",
  fontSize: 16,
});

function Campaigns() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <div>
      <Box
        sx={{
          position: "sticky",
          top: 84,
          zIndex: 1,
        }}>
        <Tabs
          sx={{
            backgroundColor: "#fff",
            "& .MuiTabs-indicator": {
              bgcolor: "primary.main",
              height: 4,
            },
          }}
          value={value}
          onChange={handleChange}>
          <TopTab label="Active" />
          <TopTab label="New" />
          <TopTab label="Closed" />
        </Tabs>
      </Box>
      <Box
        sx={{
          pt: 4,
          px: 2,
        }}>
        {value === 0 && <ActiveCampaigns />}
        {value === 1 && <NewCampaigns />}
        {value === 2 && <ClosedCampaigns />}
      </Box>
    </div>
  );
}

export default Campaigns;

async function getCampaigns(type: "active" | "new" | "closed"): Promise<Campaign[]> {
  const { data } = await axios.get(`/agent/campaigns/${type}`);
  return data;
}

function NewCampaigns() {
  const { data = [], isLoading } = useQuery(["NEW_CAMPAIGNS", "new"], () => getCampaigns("new"));

  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <FlexibleColumnGrid>
      {data.map((campaign) => (
        <CampaignCard key={campaign.id} campaign={campaign} />
      ))}
    </FlexibleColumnGrid>
  );
}

function ClosedCampaigns() {
  const { data = [], isLoading } = useQuery(["NEW_CAMPAIGNS", "closed"], () => getCampaigns("closed"));

  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <FlexibleColumnGrid>
      {data.map((campaign) => (
        <CampaignCard key={campaign.id} campaign={campaign} />
      ))}
    </FlexibleColumnGrid>
  );
}

function ActiveCampaigns() {
  const { data = [], isLoading } = useQuery(["NEW_CAMPAIGNS", "active"], () => getCampaigns("active"));

  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <FlexibleColumnGrid>
      {data.map((campaign) => (
        <InterviewCard key={campaign.id} campaign={campaign} />
      ))}
    </FlexibleColumnGrid>
  );
}

const FlexibleColumnGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: 32,
});
